<!-- Top-nav del nuevo diseño (ui-redesign). Estilos en header.component.scss + design-system (.ds). -->
<div class="ds">
	<div class="topbar">
		<div class="wrap">
			<nav class="nav">
				<a class="brand" routerLink="/home" aria-label="Acciona Centros">
					<img class="brand-logo" src="assets/images/acciona_logo.svg" alt="ACCIONA" />
				</a>
				<span class="brand-sep"></span>
				<span class="app-name">Centros</span>

				<!-- Hamburguesa (móvil) -->
				<button
					class="nav-burger"
					type="button"
					(click)="isMenuCollapsed = !isMenuCollapsed"
					aria-label="Menú"
				>
					<mat-icon>{{ isMenuCollapsed ? "menu" : "close" }}</mat-icon>
				</button>

				<div class="nav-links" [class.open]="!isMenuCollapsed">
					<ng-container *ngFor="let link of HOME_MENU_ITEMS">
						<a
							*ngIf="hasAccess(link)"
							class="nav-link"
							[routerLink]="link.url"
							[class.active]="isLinkActive(link)"
							(click)="collapseMenu()"
						>
							<span class="ic"><mat-icon>{{ link.icon }}</mat-icon></span>
							<span class="nav-link-label">{{ link.text | translate }}</span>
						</a>
					</ng-container>
				</div>

				<div class="nav-spacer"></div>

				<div class="nav-actions">
					<button
						class="icon-btn"
						type="button"
						(click)="openCommandPalette()"
						matTooltip="{{ ('header.toolbar.search' | translate) }} ({{ shortcutLabel }})"
						matTooltipClass="tooltip-red"
					>
						<span class="ic"><mat-icon>search</mat-icon></span>
					</button>
					<span class="nav-sep"></span>
					<a
						class="user"
						href="javascript:void(0)"
						(click)="emitProfile()"
						matTooltip="{{ userProfile?.name }}"
						matTooltipClass="tooltip-red"
					>
						<span class="av">
							<img *ngIf="photo" [src]="photo" alt="" />
							<ng-container *ngIf="!photo">{{ (userProfile?.name || "·") | slice : 0 : 2 | uppercase }}</ng-container>
						</span>
						<span class="who">
							<b>{{ userProfile?.name }}</b>
							<span>Acciona Agua</span>
						</span>
					</a>
				</div>
			</nav>
		</div>
	</div>
</div>
